import DataFields from "./data-fields";
import { connect } from "react-redux";
import { getValue } from 'store/languages';

let mapStateToProps = (state) => {
    return {
        fields: state.ReportConstructor.fields,
        dateFields: state.ReportConstructor.dateFields,
        selectedLanguage: state.languages.selectedLanguage,
    }
}

export default connect(mapStateToProps, {getValue})(DataFields)